export default function(enable) {

    this._options.growEnteringEdges = enable;

    return this;
};
